/**
 * TtfPostTable.ts class for EJ2-PDF
 */
var TtfPostTable = /** @class */ (function () {
    function TtfPostTable() {
    }
    return TtfPostTable;
}());
export { TtfPostTable };
